import React, { useCallback, useState, useEffect, useMemo, useContext } from 'react'
import { Link } from 'react-router-dom';
import { Image, Nav } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation, useHistory } from 'react-router-dom';
import RecordTable from './RecordTable';
import searchIcon from "../../../../../assets/icons/search.svg";
import FbIntegrationModal from '../../../../../components/Modals/FbIntegrationModal';
import { deleteIntergration, generateAccessToken, getAuthRolePermissions, getFacebookPageForms, getFbIntegrations, getIntegratedPageToEdit, updateActiveState } from '../../../../../services/private/company.service';
import { getUnion } from '../../../../../helpers/helpers';
import FbIntegrationConfirmation from '../../../../../components/Modals/FbIntegrationConfirmation';
import DeleteIntegrationModal from '../../../../../components/Modals/DeleteIntegrationModal';
import StopIntegrationModal from '../../../../../components/Modals/StopIntegrationModal';
import { ReactComponent as BackCircle } from '../../../../../assets/icons/backCircle.svg';
import { ReactComponent as Pageback } from '../../../../../assets/icons/Pageback.svg';

import Consumer from '../../../../../helpers/context';

const Forms = () => {
    const [showFbModal, setShowFbModal] = useState(localStorage.getItem('fb_modal') || false);
    const [integrations, setIntegrations] = useState([]);
    const [editMapping, setEditMapping] = useState(false);
    const [selectedIntegration, setSelectedIntegration] = useState();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [showStopIntergration, setShowStopIntergration] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [integrationPermission, setIntegrationPermission] = useState();
    const [newIntergrations, setNewIntegration] = useState(false);

    let { allowedPermissions, isRolesModule } = useContext(Consumer);

    useEffect(() => {
        if (!isRolesModule) {
            if (integrationPermission?.includes('write')) {
                setNewIntegration(true);
            }
        } else {
            if (allowedPermissions.includes('create_fb_integration')) {
                setNewIntegration(true);
            }
        }
    }, [isRolesModule, integrationPermission, allowedPermissions]);

    const { search } = useLocation();
    const history = useHistory()
    const query = new URLSearchParams(search);

    useEffect(() => {
        if (query.get('state') && query.get('state') === 're_auth') {
            history.push('/settings/integrations/all-integrations/manage-accounts')
        }
        if (query.get('code')) {
            localStorage.setItem('fb_code', query.get('code'))
            localStorage.setItem('fb_modal', true)
            history.push('/settings/integrations/all-integrations/facebook-forms/new-integration')
            // history.replace({
            //     search: ''
            // })
        }
    }, [query]);

    const getUsersAuthRolePermissions = () => {
        getAuthRolePermissions().then((res) => {
            res.data.data.map((role) => {
                if (role.module === "integration") {
                    setIntegrationPermission(role.permissions)
                }
            })
        })
    }

    useEffect(() => {
        getUsersAuthRolePermissions();
    }, []);

    const getFacebookIntegrations = useCallback(() => {
        getFbIntegrations({ searchText, created_by: query.get('created_by') || '' }).then(res => {
            setIntegrations(res.data.data);
        }).catch(err => {
            console.log({ err })
        })
    }, [searchText]);

    useEffect(() => {
        getFacebookIntegrations();
    }, [searchText]);

    const closeFbModal = useCallback(() => {
        setEditMapping(false);
        setShowFbModal(false);
    }, []);

    const showFinalConfirmaionModal = useCallback(() => {
        closeFbModal();
        setShowConfirmModal(true);
    }, [])

    const closeConfirmModal = useCallback(() => {
        setShowConfirmModal(false);
    }, []);

    const handleClearSearch = () => {
        setSearchText('');
        // setIntegrations(intergrationList);
    }

    // const getFbPageForms = useCallback((id, token) => {
    //     getFacebookPageForms({ id, token }).then(res => {
    //         const forms = res.data.data.data.map(item => {
    //             return { label: item.name, value: item.id, ...item }
    //         })
    //         setFormList([...forms]);
    //         setEditMapping(true);
    //         setShowFbModal(true);
    //     }).catch(err => {
    //         console.log({ err })
    //     })
    // }, [formMapping])

    // const selectedFormList = useMemo(() => {
    //     if (formMapping && formList) {
    //         let newForm = formList.map(item => {
    //             const result = formMapping.find(form => form.formId === item.id);
    //             if (result && Object.keys(result).length > 0) {
    //                 return { label: item.name, value: item.id, projectId: result.projectId, ...item }
    //             } else {
    //                 return { label: item.name, value: item.id, ...item }
    //             }
    //         })

    //         return newForm;
    //     }
    // }, [formMapping, formList]);

    // useEffect(() => {
    //     if (selectedFormList) {
    //         let queUnion = []
    //         // Getting union of facebook questions which is already selected
    //         selectedFormList.forEach((item) => {
    //             if (item.projectId) {
    //                 queUnion = getUnion(queUnion, item.questions)
    //             }
    //         })

    //         // mapping question with crm values
    //         let newList = queUnion.map(item => {
    //             const result = leadMapping.find(lead => lead.facebook_value === item.key)
    //             if (result && Object.keys(result).length > 0) {
    //                 return { ...item, crmValue: result.crm_value }
    //             } else {
    //                 return { ...item }
    //             }
    //         })
    //         setQuestionList(newList)
    //     }
    // }, [selectedFormList, leadMapping])

    const handleDeletePage = useCallback(() => {
        deleteIntergration(selectedIntegration.uuid).then(res => {
            if (res.data.status) {
                getFacebookIntegrations();
                toast.success(`Intergration Deleted`);
                closeDeleteIntegrationModal();
            }
        }).catch(err => {
            console.log({ err })
        })
    }, [selectedIntegration]);

    const handleShowFbIntegrationModal = useCallback(() => {
        setShowFbModal(true)
    }, [])

    const showDeleteIntergationModal = useCallback((form) => {
        setSelectedIntegration(form);
        setShowDeleteModal(true);
    }, []);


    const closeDeleteIntegrationModal = useCallback(() => {
        setShowDeleteModal(false);
    }, [])

    const closeStopIntegrationModal = useCallback(() => {
        setShowStopIntergration(false);
    }, [])

    const showStopIntergrationModal = useCallback((index, status, uuid, page_name) => {
        setSelectedIntegration({ index, status, uuid, page_name });
        setShowStopIntergration(true);
    }, [])

    const handleDeleteIntegration = useCallback((uuid) => {
        deleteIntergration(uuid).then(res => {
            if (res.data.status) {
                toast.success('Integration deleted successfully')
                getFacebookIntegrations();
            }
        })

    }, [selectedIntegration])

    const handleStopIntergration = useCallback((index, status, uuid) => {
        setIsLoading(true);
        showStopIntergration && closeStopIntegrationModal();
        setSelectedIntegration({ index, status, uuid });
        updateActiveState(uuid, { status }).then(res => {
            if (res.data.status) {
                setIsLoading(false);
                let updateIntegration = [...integrations];
                updateIntegration[index].status = status;
                setIntegrations(updateIntegration);
                toast.success(`Integration  ${status === 'ACTIVE' ? 'Active' : 'Deactivated'}`)
            }
        }).catch(err => {
            console.log({ err })
            setIsLoading(false);
        })
    }, [integrations, showStopIntergration]);

    return (
        <>
            <div className="w-100 h-full flex flex-col">
                <div className="settings-title fbintegration">
                    <div className="row">
                        <div className="col-12">
                            <nav aria-label="breadcrumb" className='inner-page-breadcrumb'>
                                <ul className="d-flex align-items-center justify-content-start flex-row mb-8">
                                    <li>
                                        <Link to='/settings/integrations/all-integrations'>All integrations </Link>
                                    </li>
                                    <li className='flex items-center'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                                        <path d="M4 3.5L8.5 8L4 12.5" stroke="#696974" />
                                    </svg>
                                        Facebook Integration
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div className="row d-flex flex-fill flex-xl-nowrap flex-wrap align-items-end">
                        <div className="col-lg-6 col-md-12 d-flex flex-fill flex-column">
                            <h1 className='fz24 black mb-0 fw-po-medium ls5 d-inline-flex align-items-center gap-x-2'>
                                <Link

                                    to='/settings/integrations/all-integrations'
                                    className="w-8 h-8 hover:bg-black200 rounded inline-flex items-center justify-center titlebackbtn"
                                >
                                    <Pageback className="group-hover:stroke-black" />
                                </Link>
                                Facebook Integration
                            </h1>
                            {/* <p className='fz16 black-dark-700 ls5 mb-0'>Connect Facebook to get leads</p> */}
                        </div>
                        <div className="col-lg-6 col-md-12 justify-content-lg-end mt-lg-0 mt-3 d-flex flex-fill align-items-center">

                            <div className={`form-group position-relative search-input ${searchText ? 'input-active' : ''}`}>
                                <div className="serch-icon">
                                    <Image src={searchIcon} />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search Page Name"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className={`searchinput`}
                                />
                                {searchText && <div className="close-icon" onClick={handleClearSearch} style={{ top: '12px' }} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M5.94131 5.00019L9.45935 8.52142C9.71958 8.78188 9.71939 9.20399 9.45892 9.46423C9.19845 9.72446 8.77634 9.72427 8.51611 9.4638L4.9978 5.9423L1.47122 9.46365C1.21067 9.7238 0.788564 9.72349 0.528408 9.46295C0.268252 9.2024 0.268566 8.78029 0.529109 8.52014L4.05542 4.99907L0.53071 1.47117C0.270478 1.2107 0.270669 0.788594 0.531136 0.528362C0.791603 0.26813 1.21371 0.268321 1.47395 0.528788L4.99893 4.05696L8.51612 0.544989C8.77666 0.284833 9.19877 0.285147 9.45893 0.54569C9.71909 0.806233 9.71877 1.22834 9.45823 1.4885L5.94131 5.00019Z" fill="#696974" />
                                    </svg>
                                </div>}
                            </div>

                            <div className="d-inline-block ml-12">
                                {newIntergrations && <Link className='pr-btn d-inline-flex align-items-center  px-16' to='/settings/integrations/all-integrations/facebook-forms/new-integration'>
                                    <svg className="mr4 d-xl-inline-block d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                                    <span className="d-xl-inline d-none ml-0 ">New Integration</span>
                                    <span className="d-xl-none ml-0">Add New</span> </Link>}
                                {/* <button
                                    // onClick={() => {
                                    //     // setConnectFacebookForm(!showConnectFacebookForm);
                                    //     // clearSelectedIntegration();
                                    //     setShowFbModal(true)
                                    // }}
                                    className="pr-btn"
                                >
                                    <svg className="mr4 d-md-inline-block d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>
                                    <span className="d-xl-inline d-none ml-0 ">New Integration</span>
                                    <span className="d-xl-none ml-0">Add New</span>

                                </button> */}
                            </div>
                            <div className="dropdown view-more ml-8">
                                <button className="bg-tr border-0 " type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z" fill="#696974" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z" fill="#696974" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z" fill="#696974" />
                                    </svg>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                    <Link className="dropdown-item" to='/settings/integrations/all-integrations/manage-accounts' >Manage account</Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <RecordTable
                    integrations={integrations}
                    // handleEditMapping={handleEditMapping}
                    handleShowFbIntegrationModal={handleShowFbIntegrationModal}
                    showDeleteIntergationModal={showDeleteIntergationModal}
                    showStopIntergrationModal={showStopIntergrationModal}
                    handleStopIntergration={handleStopIntergration}
                    handleDeleteIntegration={handleDeleteIntegration}
                    isLoading={isLoading}
                    selectedIntegration={selectedIntegration}
                    newIntergrations={newIntergrations}
                />
            </div >
            {/* {
                showFbModal &&
                <FbIntegrationModal
                    showFbModal={showFbModal}
                    closeFbModal={closeFbModal}
                    editMapping={editMapping}
                    selectedIntegration={selectedIntegration}
                    getFacebookIntegrations={getFacebookIntegrations}
                    selectedFormList={selectedFormList}
                    
                    selectedUnmappedForms={unmappedForms}
                    showConfirmModal={showConfirmModal}
                    closeConfirmModal={closeConfirmModal}
                    integrations={integrations}
                    showFinalConfirmaionModal={showFinalConfirmaionModal}
                    handleEditMapping={handleEditMapping}
                    isLoading={isLoading}
                    integrationState={integrationState}
                />
            } */}

            {
                showConfirmModal && <FbIntegrationConfirmation show={showConfirmModal} closeModal={closeConfirmModal} />
            }

            {showDeleteModal && selectedIntegration.uuid &&
                <DeleteIntegrationModal
                    selectedIntegration={selectedIntegration}
                    show={showDeleteModal}
                    closeModal={closeDeleteIntegrationModal}
                    handleDeletePage={handleDeletePage}
                />
            }


            {showStopIntergration && selectedIntegration.uuid &&
                <StopIntegrationModal
                    show={showStopIntergration}
                    closeModal={closeStopIntegrationModal}
                    selectedIntegration={selectedIntegration}
                    handleStopIntergration={handleStopIntergration}

                />}
        </>
    )
}

export default Forms;